function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 8,
  stroke: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18 9.5C17 11.5 14.4183 13 10 13C5.58172 13 3 11.5 2 9.5",
  stroke: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.64032 7C3.92077 8.6164 6.32513 9.5 10 9.5C13.6749 9.5 16.0792 8.6164 17.3597 7",
  stroke: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 10,
  cy: 10,
  rx: 3,
  ry: 8,
  stroke: "black"
});

var SvgLanguage = function SvgLanguage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLanguage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/language.f57f237a.svg";
export { ForwardRef as ReactComponent };